import React, {
    ReactElement,
    ReactNode,
} from "react";
import {
    PortalBillingProfile,
    PortalBillingSubscription,
    useGetBillingQuery,
} from "../../../../__generated__/api";
import useArticleContext from "../../../../contexts/HelpContext";
import BillingSubscription from "./BillingSubscriptions";
import BillingCheckout from "./BillingCheckout";
import useRouting, { Paths, useParams } from "../../../../contexts/Routing";

export default function BillingSettings(): ReactNode {
    useArticleContext("urn:fq:article:67d9c5ea6d6c4cbd8ec38dcd75459521");

    const { data } = useGetBillingQuery();
    const { historyPushWithSearch } = useRouting();
    const { setting, id } = useParams(Paths.ADMINISTRATOR_SETTING_ID);
    const pageSetting = useParams(Paths.ADMINISTRATOR_SETTING);

    if (pageSetting.setting === "billing-success") {
        historyPushWithSearch(Paths.ADMINISTRATOR_SETTING, { isSuccess: "true" }, { setting: "billing" });
        return null;
    }

    const subscription = setting === "billing-modify"
        ? data?.billing?.subscriptions?.find(sub => sub.encryptedSubscriptionId === id)
        : undefined;

    if (pageSetting.setting !== "billing-checkout" && !subscription && data?.billing?.subscriptions?.isNotEmpty) {
        return (
            <BillingSubscription
                subscription={data.billing.subscriptions.firstElement as PortalBillingSubscription}
                profile={data?.billing as PortalBillingProfile}
            />
        );
    }
    return (
        <BillingCheckout subscription={subscription as PortalBillingSubscription} />
    );
}
